export const translations = {
    ar: {
        appName: "سوق مدار",
        tagline: "منتجات منزلية من أسر منتجة في السعودية",
        search: "ابحث عن منتج أو متجر...",
        searchGo: "بحث",
        home: "الرئيسية",
        products: "المنتجات",
        stores: "المتاجر",
        cart: "السلة",
        login: "تسجيل الدخول",
        register: "إنشاء حساب",
        logout: "تسجيل الخروج",
        continueGoogle: "المتابعة عبر جوجل",
        or: "أو",
        emailPlaceholder: "البريد الإلكتروني",
        passwordPlaceholder: "كلمة المرور",
        namePlaceholder: "الاسم الكامل",
        phonePlaceholder: "رقم الهاتف (اختياري)",
        registerAsSeller: "أريد فتح متجر",
        registerAsCustomer: "أرغب بالشراء",
        heroTitle: "منتجات صنعت في البيوت",
        heroSub: "اكتشف روائع الطهي والحرف اليدوية من أسر منتجة في مدينتك. تسوق، ادعم، واستمتع.",
        exploreProducts: "تصفح المنتجات",
        openStore: "افتح متجرك",
        categoriesTitle: "تصفح حسب الفئة",
        featuredSellers: "متاجر مميزة",
        popularProducts: "الأكثر مبيعاً",
        newArrivals: "وصل حديثاً",
        customerReviews: "آراء العملاء",
        seeAll: "عرض الكل",
        addToCart: "أضف إلى السلة",
        buyNow: "اشتري الآن",
        outOfStock: "نفدت الكمية",
        SAR: "ر.س",
        filterByCategory: "الفئة",
        filterByCity: "المدينة",
        filterByPrice: "السعر",
        allCategories: "كل الفئات",
        allCities: "كل المدن",
        sortRecent: "الأحدث",
        sortPopular: "الأكثر مبيعاً",
        sortPriceAsc: "السعر: الأقل أولاً",
        sortPriceDesc: "السعر: الأعلى أولاً",
        productDescription: "الوصف",
        ingredients: "المكونات",
        allergens: "مسببات الحساسية",
        reviewsTitle: "التقييمات",
        similar: "منتجات مشابهة",
        estimatedDelivery: "التوصيل المتوقع",
        contactSeller: "تواصل مع البائع",
        whatsapp: "واتساب",
        shareStore: "شارك المتجر",
        seller: "البائع",
        checkout: "إتمام الشراء",
        emptyCart: "سلة التسوق فارغة",
        subtotal: "المجموع الفرعي",
        delivery: "التوصيل",
        discount: "الخصم",
        total: "الإجمالي",
        address: "العنوان",
        city: "المدينة",
        phone: "الهاتف",
        notes: "ملاحظات (اختياري)",
        coupon: "كود الخصم",
        placeOrder: "تأكيد الطلب والدفع",
        paymentSuccess: "تم الدفع بنجاح!",
        paymentSuccessSub: "شكراً لك. سيتم توصيل طلبك قريباً.",
        viewOrders: "عرض طلباتي",
        paymentCancelled: "تم إلغاء الدفع",
        myOrders: "طلباتي",
        favorites: "المفضلة",
        dashboard: "لوحة التحكم",
        sellerDashboard: "لوحة البائع",
        adminDashboard: "لوحة الأدمن",
        storeSetup: "إعداد المتجر",
        myProducts: "منتجاتي",
        addProduct: "إضافة منتج",
        editProduct: "تعديل منتج",
        title: "العنوان",
        description: "الوصف",
        price: "السعر",
        discountPrice: "سعر بعد الخصم",
        stock: "الكمية المتوفرة",
        images: "الصور",
        video: "فيديو (رابط)",
        tags: "وسوم",
        aiAssist: "المساعد الذكي",
        aiGenerate: "توليد المحتوى بالذكاء الاصطناعي",
        aiKeywordsPlaceholder: "مثال: كيكة شوكولاتة بلجيكية طازجة بالكريمة",
        aiGenerating: "جاري التوليد...",
        aiApply: "تطبيق",
        save: "حفظ",
        cancel: "إلغاء",
        delete: "حذف",
        edit: "تعديل",
        active: "نشط",
        pending: "قيد الدفع",
        confirmed: "مؤكد",
        preparing: "قيد التحضير",
        shipped: "قيد الشحن",
        delivered: "تم التوصيل",
        rejected: "مرفوض",
        status: "الحالة",
        aboutUs: "من نحن",
        deliveryInfo: "معلومات التوصيل",
        commissionSettings: "إعدادات العمولة",
        commissionPct: "نسبة العمولة (%)",
        revenue: "الإيرادات",
        commissionEarned: "العمولة المكتسبة",
        totalOrders: "إجمالي الطلبات",
        topProducts: "أفضل المنتجات",
        topStores: "أفضل المتاجر",
        newUsers: "أعضاء جدد",
        users: "المستخدمون",
        orders: "الطلبات",
        settings: "الإعدادات",
        role: "الدور",
        allProducts: "كل المنتجات",
        noResults: "لا توجد نتائج",
        writeReview: "اكتب تقييماً",
        yourRating: "تقييمك",
        yourComment: "تعليقك",
        submit: "إرسال",
        addToFavorites: "أضف للمفضلة",
        removeFromFavorites: "إزالة من المفضلة",
        aboutFooter: "منصة سعودية تجمع البائعين المنزليين بعملاء مميزين. اصنع، بع، وانمُ.",
        contactUs: "تواصل معنا",
        allRights: "جميع الحقوق محفوظة",
        productsNearMe: "منتجات قريبة منك",
        todayBest: "الأفضل اليوم",
        loginRequired: "يجب تسجيل الدخول أولاً",
        createStore: "أنشئ متجرك",
        storeName: "اسم المتجر",
        storeSlug: "رابط المتجر (بالإنجليزية)",
        deliveryFee: "رسوم التوصيل",
        aiEnhanceImage: "تحسين صورة بالذكاء الاصطناعي",
        aiRemoveBg: "إزالة الخلفية",
        upload: "رفع",
        // Phase 1 additions
        heroSlide1Title: "منتجات صنعت في البيوت",
        heroSlide1Sub: "اكتشف أفضل ما تقدمه الأسر المنتجة",
        heroSlide2Title: "خصومات اليوم تصل ٤٠٪",
        heroSlide2Sub: "عروض حصرية على أفضل المتاجر المنزلية",
        heroSlide3Title: "متاجر موثّقة ✓",
        heroSlide3Sub: "بائعون تم التحقق منهم لضمان أعلى جودة",
        todayDeals: "عروض اليوم",
        trending: "الأكثر رواجاً",
        topRated: "الأعلى تقييماً",
        recommended: "مختار لك",
        recentlyAdded: "أضيف مؤخراً",
        testimonials: "شهادات عملائنا",
        whyChooseUs: "لماذا سوق مدار؟",
        whyReason1Title: "بائعون موثّقون",
        whyReason1Body: "كل بائع يمر بمراجعة يدوية للمستندات لضمان الجودة والأمان",
        whyReason2Title: "دعم الأسر المنتجة",
        whyReason2Body: "منصة سعودية بالكامل تدعم اقتصاد الأسر ومشاريعها الصغيرة",
        whyReason3Title: "توصيل داخل مدينتك",
        whyReason3Body: "منتجات طازجة من متاجر في مدينتك، توصيل سريع من نفس اليوم",
        whyReason4Title: "مساعد AI للبائعين",
        whyReason4Body: "أدوات ذكية تساعد البائعين على تقديم أفضل تجربة تسوق",
        becomeSellerCta: "افتح متجرك الآن",
        becomeSellerTitle: "حوّل شغفك إلى مشروع",
        becomeSellerBody: "افتح متجرك المنزلي في دقائق. بدون رسوم اشتراك، عمولة عادلة، وأدوات AI مجانية.",
        appComingSoon: "قريباً — تطبيق الجوال",
        appComingBody: "احصل على إشعار عند إطلاق التطبيق على iOS و Android",
        notifyMe: "أعلمني",
        notifications: "الإشعارات",
        markAllRead: "تعيين الكل كمقروء",
        noNotifications: "لا توجد إشعارات",
        follow: "متابعة",
        following: "متابَع",
        followers: "متابعون",
        share: "مشاركة",
        wishlist: "قائمة الرغبات",
        addToWishlist: "أضف للرغبات",
        weight: "الوزن",
        prepTime: "وقت التحضير",
        deliveryTime: "وقت التوصيل",
        available: "متوفر",
        pieces: "قطعة",
        frequentlyBought: "يُشترى معاً في الغالب",
        aboutSeller: "عن البائع",
        storeCategories: "تصنيفات المتجر",
        allProducts: "جميع المنتجات",
        yearsOnPlatform: "سنوات في المنصة",
        responseTime: "وقت الرد",
        productsCount: "منتج",
        reviewsCount: "تقييم",
        verified: "موثّق",
        verifiedSeller: "بائع موثّق",
        verification: "التوثيق",
        verificationSubmit: "أرسل مستنداتك للتوثيق",
        verificationPending: "قيد المراجعة",
        verificationApproved: "تمت الموافقة ✓",
        verificationRejected: "مرفوض",
        docNationalId: "الهوية الوطنية",
        docFreelance: "رخصة العمل الحر",
        docCommercial: "السجل التجاري",
        docNumber: "رقم المستند",
        submitDoc: "إرسال",
        pendingApprovals: "موافقات معلّقة",
        approve: "موافقة",
        reject: "رفض",
        rejectReason: "سبب الرفض",
        deliveryRating: "تقييم التوصيل",
        packagingRating: "تقييم التغليف",
        sellerRating: "تقييم البائع",
        overallRating: "التقييم العام",
        addPhoto: "أضف صورة",
        customerPhotos: "صور العملاء",
        newProduct: "منتج جديد",
        buyNow: "اشتري الآن",
        visitStore: "زيارة المتجر",
        zoomImage: "تكبير الصورة",
        // Phase 1.5 — Chat
        chat: "المحادثة",
        chats: "المحادثات",
        contactSellerChat: "تواصل مع البائع",
        supportChat: "شات الدعم",
        support: "الدعم",
        typeMessage: "اكتب رسالة...",
        send: "إرسال",
        online: "متصل الآن",
        lastSeen: "آخر ظهور",
        lastSeenJustNow: "آخر ظهور قبل لحظات",
        lastSeenMinutes: "آخر ظهور قبل {n} دقيقة",
        lastSeenHours: "آخر ظهور قبل {n} ساعة",
        lastSeenDays: "آخر ظهور قبل {n} يوم",
        noConversations: "لا توجد محادثات",
        startConversation: "ابدأ محادثة",
        selectConversation: "اختر محادثة",
        needHelp: "تحتاج مساعدة؟",
        supportWelcome: "أهلاً بك في الدعم الفني، كيف يمكننا مساعدتك؟",
        yesterday: "أمس",
        // Reels
        reels: "الفيديوهات",
        reelsFeed: "الفيديوهات الرائجة",
        addReel: "أضف فيديو",
        myReels: "فيديوهاتي",
        reelCaption: "شرح الفيديو (اختياري)",
        linkProduct: "اربط منتج (اختياري)",
        uploadVideo: "ارفع الفيديو (حتى 30 ثانية)",
        views: "مشاهدة",
        likes: "إعجاب",
        reelPublish: "نشر",
        reelHint: "أضف فيديو قصير (10-30 ثانية) لعرض منتجك بشكل جذاب",
        watchOnReels: "شاهد على Reels",
        discoverReels: "اكتشف عبر الفيديوهات",
    },
    en: {
        appName: "Souq Madar",
        tagline: "Home-based businesses across Saudi Arabia",
        search: "Search products or stores...",
        searchGo: "Search",
        home: "Home",
        products: "Products",
        stores: "Stores",
        cart: "Cart",
        login: "Sign In",
        register: "Sign Up",
        logout: "Sign Out",
        continueGoogle: "Continue with Google",
        or: "or",
        emailPlaceholder: "Email",
        passwordPlaceholder: "Password",
        namePlaceholder: "Full name",
        phonePlaceholder: "Phone (optional)",
        registerAsSeller: "I want to open a store",
        registerAsCustomer: "I want to shop",
        heroTitle: "Made in Saudi homes",
        heroSub: "Discover the finest homemade food, crafts and gifts from productive families near you. Shop, support, savour.",
        exploreProducts: "Explore Products",
        openStore: "Open your store",
        categoriesTitle: "Browse categories",
        featuredSellers: "Featured stores",
        popularProducts: "Best sellers",
        newArrivals: "New arrivals",
        customerReviews: "Customer reviews",
        seeAll: "See all",
        addToCart: "Add to cart",
        buyNow: "Buy now",
        outOfStock: "Out of stock",
        SAR: "SAR",
        filterByCategory: "Category",
        filterByCity: "City",
        filterByPrice: "Price",
        allCategories: "All categories",
        allCities: "All cities",
        sortRecent: "Newest",
        sortPopular: "Best sellers",
        sortPriceAsc: "Price: low to high",
        sortPriceDesc: "Price: high to low",
        productDescription: "Description",
        ingredients: "Ingredients",
        allergens: "Allergens",
        reviewsTitle: "Reviews",
        similar: "Similar products",
        estimatedDelivery: "Estimated delivery",
        contactSeller: "Contact seller",
        whatsapp: "WhatsApp",
        shareStore: "Share store",
        seller: "Seller",
        checkout: "Checkout",
        emptyCart: "Your cart is empty",
        subtotal: "Subtotal",
        delivery: "Delivery",
        discount: "Discount",
        total: "Total",
        address: "Address",
        city: "City",
        phone: "Phone",
        notes: "Notes (optional)",
        coupon: "Coupon code",
        placeOrder: "Place order & pay",
        paymentSuccess: "Payment successful!",
        paymentSuccessSub: "Thank you. Your order will be delivered soon.",
        viewOrders: "View my orders",
        paymentCancelled: "Payment cancelled",
        myOrders: "My orders",
        favorites: "Favorites",
        dashboard: "Dashboard",
        sellerDashboard: "Seller dashboard",
        adminDashboard: "Admin dashboard",
        storeSetup: "Store setup",
        myProducts: "My products",
        addProduct: "Add product",
        editProduct: "Edit product",
        title: "Title",
        description: "Description",
        price: "Price",
        discountPrice: "Discounted price",
        stock: "Stock quantity",
        images: "Images",
        video: "Video (URL)",
        tags: "Tags",
        aiAssist: "AI Assistant",
        aiGenerate: "Generate content with AI",
        aiKeywordsPlaceholder: "e.g. fresh Belgian chocolate cake with cream",
        aiGenerating: "Generating...",
        aiApply: "Apply",
        save: "Save",
        cancel: "Cancel",
        delete: "Delete",
        edit: "Edit",
        active: "Active",
        pending: "Pending payment",
        confirmed: "Confirmed",
        preparing: "Preparing",
        shipped: "Shipped",
        delivered: "Delivered",
        rejected: "Rejected",
        status: "Status",
        aboutUs: "About us",
        deliveryInfo: "Delivery info",
        commissionSettings: "Commission settings",
        commissionPct: "Commission (%)",
        revenue: "Revenue",
        commissionEarned: "Commission earned",
        totalOrders: "Total orders",
        topProducts: "Top products",
        topStores: "Top stores",
        newUsers: "New users",
        users: "Users",
        orders: "Orders",
        settings: "Settings",
        role: "Role",
        allProducts: "All products",
        noResults: "No results",
        writeReview: "Write a review",
        yourRating: "Your rating",
        yourComment: "Your comment",
        submit: "Submit",
        addToFavorites: "Add to favourites",
        removeFromFavorites: "Remove from favourites",
        aboutFooter: "A Saudi marketplace that brings home-based sellers together with delightful customers. Make, sell, grow.",
        contactUs: "Contact us",
        allRights: "All rights reserved",
        productsNearMe: "Near you",
        todayBest: "Today's best",
        loginRequired: "Please sign in first",
        createStore: "Create your store",
        storeName: "Store name",
        storeSlug: "Store URL (in English)",
        deliveryFee: "Delivery fee",
        aiEnhanceImage: "AI enhance image",
        aiRemoveBg: "Remove background",
        upload: "Upload",
        // Phase 1 additions
        heroSlide1Title: "Made in Saudi homes",
        heroSlide1Sub: "Discover the best of home-based businesses",
        heroSlide2Title: "Today's deals up to 40% off",
        heroSlide2Sub: "Exclusive offers from top home stores",
        heroSlide3Title: "Verified stores ✓",
        heroSlide3Sub: "Every seller reviewed for premium quality",
        todayDeals: "Today's deals",
        trending: "Trending",
        topRated: "Top rated",
        recommended: "For you",
        recentlyAdded: "Recently added",
        testimonials: "Testimonials",
        whyChooseUs: "Why Souq Madar?",
        whyReason1Title: "Verified sellers",
        whyReason1Body: "Every seller goes through manual document review for safety and quality",
        whyReason2Title: "Support home businesses",
        whyReason2Body: "A Saudi-first marketplace empowering family entrepreneurs across the kingdom",
        whyReason3Title: "Local delivery",
        whyReason3Body: "Fresh products from your city — often delivered the same day",
        whyReason4Title: "AI seller tools",
        whyReason4Body: "Smart tools help sellers present a premium shopping experience",
        becomeSellerCta: "Open your store",
        becomeSellerTitle: "Turn your passion into a business",
        becomeSellerBody: "Set up your home store in minutes. No subscription, fair commission, free AI tools included.",
        appComingSoon: "Coming soon — Mobile app",
        appComingBody: "Get notified when we launch on iOS and Android",
        notifyMe: "Notify me",
        notifications: "Notifications",
        markAllRead: "Mark all as read",
        noNotifications: "No notifications",
        follow: "Follow",
        following: "Following",
        followers: "followers",
        share: "Share",
        wishlist: "Wishlist",
        addToWishlist: "Add to wishlist",
        weight: "Weight",
        prepTime: "Prep time",
        deliveryTime: "Delivery time",
        available: "Available",
        pieces: "pieces",
        frequentlyBought: "Frequently bought together",
        aboutSeller: "About the seller",
        storeCategories: "Store categories",
        allProducts: "All products",
        yearsOnPlatform: "Years on platform",
        responseTime: "Response time",
        productsCount: "products",
        reviewsCount: "reviews",
        verified: "Verified",
        verifiedSeller: "Verified seller",
        verification: "Verification",
        verificationSubmit: "Submit documents for verification",
        verificationPending: "Under review",
        verificationApproved: "Approved ✓",
        verificationRejected: "Rejected",
        docNationalId: "National ID",
        docFreelance: "Freelance license",
        docCommercial: "Commercial registration",
        docNumber: "Document number",
        submitDoc: "Submit",
        pendingApprovals: "Pending approvals",
        approve: "Approve",
        reject: "Reject",
        rejectReason: "Reason for rejection",
        deliveryRating: "Delivery rating",
        packagingRating: "Packaging rating",
        sellerRating: "Seller rating",
        overallRating: "Overall rating",
        addPhoto: "Add photo",
        customerPhotos: "Customer photos",
        newProduct: "New product",
        buyNow: "Buy now",
        visitStore: "Visit store",
        zoomImage: "Zoom image",
        // Phase 1.5 — Chat
        chat: "Chat",
        chats: "Chats",
        contactSellerChat: "Chat with seller",
        supportChat: "Support chat",
        support: "Support",
        typeMessage: "Type a message...",
        send: "Send",
        online: "Online",
        lastSeen: "Last seen",
        lastSeenJustNow: "Last seen just now",
        lastSeenMinutes: "Last seen {n}m ago",
        lastSeenHours: "Last seen {n}h ago",
        lastSeenDays: "Last seen {n}d ago",
        noConversations: "No conversations",
        startConversation: "Start a conversation",
        selectConversation: "Select a conversation",
        needHelp: "Need help?",
        supportWelcome: "Welcome to support, how can we help?",
        yesterday: "Yesterday",
    },
};
